<template>
  <div class="inlineFrame" :class="{ '-embed': embedFrame }">
    <slot></slot>
  </div>
</template>

<script lang="ts">
export default {
  name: 'InlineFrame',

  props: {
    embedFrame: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.inlineFrame {
  overflow: auto;
  height: 290px;
  margin-top: 15px;
  padding: 20px;
  border: 1px solid var.$color-border-gray;
  border-radius: 4px;
  margin-bottom: 24px;

  &.-embed {
    overflow: hidden;
    padding: 0;
    height: auto;

    // iframe {
    //   height: 180px;

    //   @include mixins.media() {
    //     height: 150px;
    //   }
    // }
  }

  // &.-sm {
  //   height: 180px;

  //   @include mixins.media() {
  //     height: 150px;
  //   }
  // }

  & + & {
    margin-top: -8px;
  }
}

::v-deep(iframe) {
  // height: 180px;

  // @include mixins.media() {
  height: 150px;
  // }
}
</style>
